import { faRadiation as faRadiationLight } from '@fortawesome/pro-light-svg-icons';
import { faGears } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';

import { UpdateAppForm } from '~/components/forms/AppForm';
import { UpdateAppOrganizationForm } from '~/components/forms/AppOrganizationForm';
import { Breadcrumbs } from '~/components/molecules/Breadcrumbs';
import { Heading } from '~/components/molecules/Heading';
import { AppInfo } from '~/components/organisms/AppInfo';
import { AppBreadcrumbs } from '~/components/organisms/Breadcrumbs';
import { useNavigate } from '~/components/utils/Navigation';

export type IAppAdvancedSettingsPageProps = {
  appId: string;
  nextUrl?: string;
  cancelUrl?: string;
};

export const AppAdvancedSettingsPage: React.FC<
  IAppAdvancedSettingsPageProps
> = (props) => {
  const { appId, nextUrl, cancelUrl } = props;
  const navigate = useNavigate();
  const { t } = useTranslation();

  const defaultNextUrl = `/apps/${appId}`;
  const parentUrl = `/apps/${appId}/settings`;

  return (
    <>
      <Helmet>
        <title>{t('AppAdvancedSettingsPage.seo.title')}</title>
      </Helmet>

      <AppBreadcrumbs appId={appId}>
        <Breadcrumbs.Action href={parentUrl}>
          <FontAwesomeIcon icon={faGears} />
          {t('common.settings')}
        </Breadcrumbs.Action>
      </AppBreadcrumbs>

      <Heading
        icon={<FontAwesomeIcon icon={faRadiationLight} />}
        title={t('AppAdvancedSettingsPage.title')}
        subtitle={t('AppAdvancedSettingsPage.subtitle')}
        previousUrl={parentUrl}
      />

      <AppInfo appId={appId} />
      <UpdateAppForm
        appId={appId}
        onSuccess={nextUrl ? () => navigate(nextUrl) : undefined}
        cancelUrl={cancelUrl ?? parentUrl}
      />
      <UpdateAppOrganizationForm
        appId={appId}
        onSuccess={() => navigate(nextUrl ?? defaultNextUrl)}
        cancelUrl={cancelUrl ?? parentUrl}
      />
    </>
  );
};
